import routes from './env-routes';

const formatArrayQuery = (queryKey, queryValue) => {
  const valueIsArray = Array.isArray(queryValue);
  const keyIsString = typeof queryKey === 'string' || queryKey instanceof String;

  if (!valueIsArray || !keyIsString) return '';

  return queryValue?.map((value) => `${queryKey}=${value}`).join('&');
};

const formatArrayQueries = (params) => {
  const queryParams = Object.keys(params);

  if (!queryParams.length) return '';

  const queryString = queryParams.reduce((query, key) => {
    const queryValue = params[key];

    // language is always sent through base URL so we can prevent language from being sent as a query parameter here globally
    if (key === 'language') return query;

    if (Array.isArray(queryValue) && queryValue.length) {
      const formattedQuery = formatArrayQuery(key, queryValue);
      query.push(formattedQuery);
      return query;
    }

    query.push(`${key}=${queryValue}`);
    return query;
  }, []);

  return queryString.join('&') || '';
};

const successPayload = (response) => ({
  data: response?.data?.data || response?.data || [],
  status: response?.status || 0,
  paginationInfo: response?.data?.paginationInfo || response?.data?.pagination || {},
  success: true,
});

const errorPayload = (error) => ({
  data:
    error?.response?.data?.error ||
    error?.text ||
    JSON.parse(error?.response?.data) ||
    error?.message ||
    {},
  status: error?.response?.data?.status || error?.response?.status || 0,
  error: true,
});

const coreURLConstruct = (params = {}) => {
  const instance = localStorage.getItem('instance');
  const languageParam = params.language ?? localStorage.getItem('language');

  return `${routes.aioCore}/tenants/${window.tenantUuid}/instances/${instance}/languages/${languageParam}`;
};

const betslipURLConstruct = () => {
  return `${routes.betslip}/api/v1/admin`;
};

const betsURLConstruct = () => {
  const languageParam = localStorage.getItem('language');

  return `${routes.bets}/tenants/${window.tenantUuid}/languages/${languageParam}`;
};

const feedMappingsURLConstruct = (tenantUuid = null) => {
  // const languageParam = localStorage.getItem('language');
  const uuid = tenantUuid || window.tenantUuid;
  return `${routes.feedMappings}/tenants/${uuid}`;
};

const liabilityURLConstruct = () => {
  return `${routes.liability}/api/v1/admin/tenants/${window.tenantUuid}`;
};

const betsBaseURLConstruct = () => routes.bets;

const liabilityMonitoringURLConstruct = (params = {}) => {
  const languageParam = params.language ?? localStorage.getItem('language');

  return `${routes.liability}/api/v1/admin/tenants/${window.tenantUuid}/monitoring/languages/${languageParam}`;
};

const mapLangugageCodes = (languageList) => {
  const languageCodes = {};

  for (const language of languageList) {
    languageCodes[language.id] = language.code;
  }

  return languageCodes;
};

const getCurrencySymbolFromISOCode = (isoCode) => {
  try {
    const language = localStorage.getItem('language');
    const formatter = new Intl.NumberFormat(language || 'en', {
      style: 'currency',
      currency: isoCode,
      currencyDisplay: 'symbol',
    });

    const formattedNum = formatter.format(0);
    const currencySymbol = formattedNum.replace(/0|\.00|,00/g, '').trim();

    return currencySymbol !== isoCode ? currencySymbol : '';
  } catch (error) {
    console.error(`Error with getting currency symbol with ISO code: ${isoCode}`, error);
    return '';
  }
};

export {
  coreURLConstruct,
  betsURLConstruct,
  betslipURLConstruct,
  betsBaseURLConstruct,
  liabilityURLConstruct,
  liabilityMonitoringURLConstruct,
  formatArrayQuery,
  formatArrayQueries,
  errorPayload,
  successPayload,
  mapLangugageCodes,
  feedMappingsURLConstruct,
  getCurrencySymbolFromISOCode,
};
